import type { CarOrderDetailCarInfo } from "@/api/car";

type Props = {
  car: CarOrderDetailCarInfo;
  gearboxText: string;
};

export default function CarConfigSection({ car, gearboxText }: Props) {
  return (
    <div className="mx-4 mt-3 bg-white rounded-2xl p-4">
      <div className="text-sm font-bold text-gray-900 mb-3">车辆配置</div>
      <div className="space-y-2 text-xs">
        {[
          ["变速箱", gearboxText],
          ["座位数", car.seats_text || `${car.seats}座`],
          ["排量", car.displacement || "—"],
          ["是否含司机", car.has_driver_text],
        ].map(([k, v]) => (
          <div
            key={String(k)}
            className="flex items-center justify-between py-2"
            style={{ borderBottom: "1px solid #F5F5F5" }}
          >
            <span className="text-gray-500">{k}</span>
            <span className="text-gray-800 font-medium">{v}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
